import { useState, useEffect, Suspense } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, json, Form } from 'react-router-dom'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/PassagePrint.module.scss'
import printStyles from '../styles/module/Print.module.scss'
import LoadingSpinner from './components/LoadingSpinner'
import { getRequestDetail, getPrintData } from '../util/p_api'
import '../../node_modules/leaflet-draw/dist/leaflet.draw.css'
import { useAuth } from '../contexts/AuthContext'
import logo from '../../src/logo.svg'
import Download from './download'

export default function PassageList({ title }) {
    Title(title)
    const [loaderData, setLoaderData] = useState(useLoaderData())
    const [error, setError] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState()
    const [printData, setPrintData] = useState([])
    const [user, setUser] = useState(null)
    let [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()

    const HTMLcontent = (data) => {
        return { __html: data }
    }

    useEffect(() => {
        document.querySelector("header span").innerText = `پرینت`

        getRequestDetail(searchParams.get('requestId')).then(res => {
            console.log(res)
            setData(res)
        })

        getPrintData().then(res => {
            setPrintData(res)
            console.log(res)
        })
    }, [])

    return <section className={styles.section}>
        <div className={`__frame`} data-width={`xlarge`}>
            {
                printData && printData.length > 0 && data && data.request.map((item, itemIndex) => {
                    return <div key={itemIndex} id='content' className={printStyles.container}>

                        <ul className={`${printStyles.header} d-flex justify-content-between`}>
                            <li className='d-flex flex-column align-items-start justify-content-center'>
                                <figure>
                                    <img alt='' src={logo} draggable={false} />
                                    <figcaption>شهرداری اردبیل</figcaption>
                                </figure>
                            </li>
                            <li className='d-flex flex-column align-items-center justify-content-center text-center'>
                                <b>بسمه تعالی</b>
                                <p>فرم درخواست نامگذاری معابر عمومی</p>
                            </li>
                            <li className='d-flex flex-column align-items-end justify-content-center'>
                                <ul>
                                    <li dir={`ltr`} className='d-flex flex-row align-items-center justify-content-between' style={{columnGap:'1rem'}}>
                                        <span>{item.dt.split(' ')[0]} </span>
                                        <span>:تاریخ</span>
                                    </li>

                                    <li dir={`ltr`}  className='d-flex flex-row align-items-center justify-content-between' style={{columnGap:'1rem'}}>
                                        <span>{item.dt.split(' ')[1]} </span>
                                        <span>:ساعت</span>
                                    </li>

                                    <li dir={`ltr`}  className='d-flex flex-row align-items-center justify-content-between' style={{columnGap:'1rem'}}>
                                        <span dir={`ltr`}>{item.id}</span>
                                        <span>:شماره</span>
                                    </li>
                                </ul>

                            </li>
                        </ul>

                        <main>
                            <ul className={styles.detailList}>
                                <li>
                                    <b>متقاضی:</b>
                                    <span> {item.fullname}</span>
                                </li>
                                <li>
                                    <b>آدرس دقیق محل مورد نظر:</b>
                                    <span> {item.address}</span>
                                </li>
                                <li>
                                    <b>موضوع درخواست نامگذاری:</b>
                                    <span> {item.request_type_name}</span>
                                </li>
                                <li>
                                    <b>عنوان تابلو در صورت موجود بودن:</b>
                                    <span> {item.title}</span>
                                </li>
                                <li>
                                    <b>نام محل (به چه نامی مشهور است):</b>
                                    <span> {item.name}</span>
                                </li>
                                <li>
                                    <b>نام های پیشنهادی:</b>
                                    <span> {JSON.parse(item.suggestion_names).join(' - ')}</span>
                                </li>
                            </ul>


                            <div className={`d-flex justify-content-between align-items-center`} style={{ marginTop: '2rem' }}>
                                <div>
                                    <b>تاییدیه بنیاد شهید و امور ایثارگران</b>
                                    <br />
                                    <small>در صورت شهید یا جانباز بودن نام پیشنهادی</small>
                                </div>
                                <div>
                                    <b>تاییدیه هیئت امنا، انجمن اسلامی یا پایگاه محله</b>
                                </div>
                            </div>


                            <p style={{ marginTop: '5rem' }}>محل امضا ساکنین محل:</p>
                            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                        </main>

                        <div dangerouslySetInnerHTML={{ __html: `<small>${printData[0]['end_line']}</small>` }} style={{textAlign:'center', lineHeight:'13px'}} /> 

                        <div className={`${printStyles.footer} `}>
                            <div dangerouslySetInnerHTML={{ __html: printData[0]['footer'] }}></div>
                        </div>
                    </div>
                })
            }


            <div className='text-center' style={{ textAlign: 'center', marginTop: '1rem' }}>
                <button onClick={() => window.print()}>پرینت</button>
                <button onClick={() => navigate('/passage/list')}>بازگشت به صفحه درخواست ها</button>
            </div>


        </div>
    </section>
}